var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-active-models"},[(_vm.loading)?_c('span',[_vm._v("Loading")]):_c('span',[_c('ActiveModel',{attrs:{"modelsOnline":_vm.modelsOnline}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }